import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { IEntityAppointmentSearchResponse } from './typings'
import { completeAppointment, searchExistingAppointments } from './api'

const entityAppointmentsSearchAdapter =
  createEntityAdapter<IEntityAppointmentSearchResponse>({})

type State = {
  loading: boolean
}

export const initialState =
  entityAppointmentsSearchAdapter.getInitialState<State>({
    loading: false,
  })

const entityAppointmentsSearch = createSlice({
  name: 'entityAppointmentsSearch',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      searchExistingAppointments.fulfilled,
      (state, { payload }) => {
        state.loading = false
        entityAppointmentsSearchAdapter.setAll(state, payload ?? [])
      },
    )

    builder.addCase(searchExistingAppointments.pending, (state) => {
      state.loading = true
    })

    builder.addCase(searchExistingAppointments.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(completeAppointment.fulfilled, (state, { meta }) => {
      const {
        appointmentId,
        requestInput: { notServicedReason },
      } = meta.arg

      const cancelled = !!notServicedReason

      entityAppointmentsSearchAdapter.updateOne(state, {
        id: appointmentId,
        changes: {
          status: cancelled ? 'Cancelled' : 'Completed',
        },
      })
    })
  },
})

export default entityAppointmentsSearch.reducer

const selectors = entityAppointmentsSearchAdapter.getSelectors<StoreData>(
  (state) => state.entityAppointmentsSearch,
)

export const { selectAll: selectEntityAppointmentsSearch } = selectors

export const selectEntityAppointmentsSearchLoading = (state: StoreData) =>
  state.entityAppointmentsSearch.loading
